import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type RegisterPushWebRequest = {
  endpoint: string;
  p256dh: string;
  auth: string;
};

export type RegisterPushWebParams = RequestConfig<RegisterPushWebRequest>;

export const registerPushWeb = async ({
  params,
  config
}: RegisterPushWebParams) => api.post('/api/push/register-web', params, config);
